var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TopicContentActions = void 0;
const react_1 = __importDefault(require("react"));
const core_1 = require("@wheelroom/core");
exports.TopicContentActions = (props) => {
    const actions = props.topic.actions;
    if (!actions) {
        return null;
    }
    return (react_1.default.createElement(core_1.Box, { is: "div", wheel: Object.assign(Object.assign({}, props.wheel), { style: props.wheel.style.actionGroup }) }, actions
        .slice(0, props.maxActions)
        .map((action, index) => {
        const modifiedAction = Object.assign({}, action);
        modifiedAction.url = props.fullTopicAsLink ? undefined : action.url;
        modifiedAction.page = props.fullTopicAsLink ? undefined : action.page;
        return (react_1.default.createElement(core_1.Action, Object.assign({ key: index, wheel: Object.assign(Object.assign({}, props.wheel), { style: props.wheel.style.action }) }, modifiedAction)));
    })));
};
//# sourceMappingURL=topic-content-actions.js.map